import { configureStore } from "@reduxjs/toolkit";
import employeeReducer from "./slices/employeeSlice";
import employeeCountReducer from "./slices/Dashboard/employeeCountSlice"
import employeeDetailReducer from "./slices/employeeDetailSlice";
import employeePersonalDetailReducer from "./slices/employeePersonalDetailSlice";
import authReducer from "./slices/Auth/authSlice";
import employeeAddressReducer from "./slices/employeeAddressSlice";
import employeeHistoryReducer from "./slices/employeeEmploymentHistorySlice";
import branchReducer from "./slices/branchSlice";
import companyTypeReducer from "./slices/companySlice";
import userReducer from "./slices/userSlice";
import jobtitleReducer from "./slices/jobtitleSlice";
import departmentReducer from "./slices/departmentSlice";
import roleReducer from "./slices/roleSlice";
import employeeContactReducer from "./slices/employeeContactSlice";
import governmentDocumentReducer from "./slices/governmentDocumentSlice";
import educationBackgroundReducer from "./slices/educationBackgroundSlice";
import employeeEmergencyContactReducer from "./slices/emergencyContactSlice";
import employeeUploadReducer from "./slices/employeeUploadSlice";
import employeeImageReducer from "./slices/employeeImageSlice";
import employeeImportReducer from "./slices/importLogSlice"; 
import clientReducer from "./slices/clientSlice";
import bulkActionReducer from "./slices/bulkActionSlice"; 
// 1. Import the new Storage Config Reducer
import storageConfigReducer from "./slices/storageConfigSlice"; 
import auditLogsReducer from "./slices/auditLogsSlice";
import bulkSyncReducer from "./slices/syncSlice";
import employeeLeaveReducer from "./slices/LeaveManagement/employeeLeaveSlice"
import leavePolicyReducer from "./slices/LeaveManagement/leavePolicy"
import leaveHierarchyCountReducer from "./slices/Dashboard/pendingLeaveSlice"; 

export const store = configureStore({
  reducer: {
    employee: employeeReducer,
    employeeCount: employeeCountReducer,
    employeeDetail: employeeDetailReducer,
    branch: branchReducer,
    companyTypeList: companyTypeReducer,
    employeePersonalDetail: employeePersonalDetailReducer,
    employeeAddress: employeeAddressReducer,
    employeeHistory: employeeHistoryReducer,
    auth: authReducer,
    user: userReducer,
    jobtitle: jobtitleReducer,
    department: departmentReducer,
    role: roleReducer,
    employeeContact: employeeContactReducer,
    governmentDocument: governmentDocumentReducer,
    employeeEducation: educationBackgroundReducer,
    employeeEmergencyContact: employeeEmergencyContactReducer,
    employeeUpload: employeeUploadReducer,
    employeeImage: employeeImageReducer,
    employeeImport: employeeImportReducer, 
    client: clientReducer,
    audit: auditLogsReducer,
    bulkAction: bulkActionReducer, 
    storageConfig: storageConfigReducer, 
    bulkSync: bulkSyncReducer,
    employeeLeave: employeeLeaveReducer,
    employeeLeavePolicy: leavePolicyReducer,
    leaveHierarchyCount: leaveHierarchyCountReducer,
  },
});